import {mount} from "svelte";
import App from "./App.svelte";

const config = Object.freeze({
    "stitch_name": "TempPONSManageProcedures",
    "stitch_site": "stitch_site" // div id in index.html to load stitch (for localhost dev)
});

////////////////////////////////////////
// NOTE: Don't modify the below, only the config above

/** @type {any} */
let app;

const site = document.getElementById(config.stitch_site);

if (site) {
    app = mount(App, {target: site});
}

export default app;